import React, { useContext } from 'react';

import {
    Routes, Route, Navigate
} from 'react-router-dom';

import { CurrentUser } from '../App';

import EmployeeLayout from '../components/Layout/EmployeeLayout';
import BaseLayout from '../components/Layout/BaseLayout';
import EmployerLayout from '../components/Layout/EmployerLayout';
import Dashboard from '../pages/Dashboard';
import HelpAndSupport from '../pages/HelpAndSupport';
import OnboardingFlow from '../pages/Onboarding/Flow';
import Profile from '../pages/Profile';
import QuestionnaireFlow from '../pages/Questionnaire/Flow';
import Favourites from '../pages/Favourites';
import Rewards from '../pages/Rewards';
import ResourcesFlow from '../pages/Resources/Flow';
import PrivacyPolicy from '../pages/General/PrivacyPolicy';
import CookiePolicy from '../pages/General/CookiePolicy';
import Terms from '../pages/General/Terms';
import Workshops from '../pages/Workshops';
import Newsletter from '../pages/Resources/Newsletter'; 
import Overview from '../pages/Employer/Overview';
import Users from '../pages/Employer/Users';
import UserCreate from '../pages/Employer/Users/UserCreate';
import UserEdit from '../pages/Employer/Users/UserEdit';
import Resources from '../pages/Employer/Resources';
import ResourceCreate from '../pages/Employer/Resources/ResourceCreate';
import ResourceEdit from '../pages/Employer/Resources/ResourceEdit';
import Resource from '../pages/Employer/Resource';
import Settings from '../pages/Employer/Settings';
import Chatbot from '../pages/Chatbot';
import PublicQuestionnaire from '../pages/PublicQuestionnaire';

const AppRoutes = () => {
    const {user} = useContext(CurrentUser)

    const isEmployer = user.user.user_type === 'employer'

    let employeelinks = [
        { path: "/dashboard", text: "Home", className: null },
        { path: "/workshops", text: "Workshops", className: null },
        { path: "/resources", text: "Resources", className: null},
        { path: "/favourites", text: "Favourites", className: null },
        { path: "/rewards", text: "Rewards", className: null },
        { path: "/support", text: "Help and Support", className: null }
    ];

    let employerLinks = [
        { path: "/employer/overview", text: "Overview", className: null },
        { path: "/employer/settings", text: "Settings", className: null },
        { path: "/employer/resources", text: "Resources", className: null },
        { path: "/employer/users", text: "Users", className: null },
        { path: "/", text: "Employee View", className: "btn btn-sm btn-purple" }
    ];

    if(isEmployer){
        employeelinks.push({ path: "/employer", text: "Employer View",  className: "btn btn-sm btn-purple"  })
    }

    return (
        <Routes>
            <Route path="/entry" element={<Navigate to={isEmployer ? '/employer' : '/'} replace />} />
            <Route path="/chatbot" element={<Chatbot />} />
            <Route path="/" element={<Navigate to={user.user.completed_onboarding ? '/dashboard' : '/onboarding'} replace />} />
            <Route path="/" element={<BaseLayout links={employeelinks} />}>
                <Route path="onboarding/*" element={<OnboardingFlow />} />
                <Route path="onboarding" element={<Navigate to="/onboarding/step-1" replace />} />
                <Route path="questionnaire/*" element={<QuestionnaireFlow />} />
            </Route>
            <Route path="/" element={<EmployeeLayout links={employeelinks} banner={true} />}>
                <Route path="dashboard" element={<Dashboard />} />
            </Route>
            <Route path="/" element={<EmployeeLayout links={employeelinks} />}>
                <Route path="workshops" element={<Workshops />} />
                <Route path="profile" element={<Profile />} />
                <Route path="rewards" element={<Rewards />} />
                <Route path="newsletter/onsite/:id"  element={<Newsletter />} />
                <Route path="resources/*" element={<ResourcesFlow />} />
                <Route path="favourites" element={<Favourites />} />
                <Route path="support" element={<HelpAndSupport />} />
                <Route path="privacy" element={<PrivacyPolicy />} />
                <Route path="cookies" element={<CookiePolicy />} />
                <Route path="terms" element={<Terms />} />
            </Route>
            <Route path="share/questionnaire/:uuid" element={<PublicQuestionnaire />} />
            {isEmployer && (
                <>
                    <Route path="/employer" element={<EmployerLayout links={employerLinks} banner={true} />}>
                        <Route path="" element={<Navigate to="/employer/overview" replace />} />
                        <Route path="overview" element={<Overview />} />
                    </Route>

                    <Route path="/employer" element={<EmployerLayout links={employerLinks} />}>
                        <Route path="users" element={<Users />} />
                        <Route path="users/create" element={<UserCreate />} />
                        <Route path="users/:id/edit" element={<UserEdit />} />
                        <Route path="resources" element={<Resources />} />
                        <Route path="resources/create" element={<ResourceCreate />} />
                        <Route path="resources/:type/:id" element={<Resource />} />
                        <Route path="resources/:type/:id/edit" element={<ResourceEdit />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="*" element={<Navigate to="/employer/overview" replace />} />
                    </Route>
                </>
            )}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default AppRoutes;